/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updaterequireddescription2Inputs */



/**
* | output |
* | --- |
* | "Luni just got even more convenient to use" |
*
* @param {Updaterequireddescription2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const updaterequireddescription2 = /** @type {((inputs?: Updaterequireddescription2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updaterequireddescription2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Luni just got even more convenient to use")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usar Luni es ahora aún más cómodo")
	return /** @type {LocalizedString} */ ("Пользоваться Луни стало ещё удобнее")
});
export { updaterequireddescription2 as "updateRequiredDescription" }